import styled from 'styled-components';
import { CarGalleryStyled } from '../CarGalleryStyled';

export const CarGalleryStyledAP = styled(CarGalleryStyled)`
    .button-wrapper {
        button {
            color: ${({ theme }) => theme.colors.primaryBlack};
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        }
    }
`;
